import { ChangeDetectionStrategy, Component, computed, inject, model, signal } from '@angular/core';
import { AbstractComponent } from '@spike/scaffolds';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { Trade } from '../../models/trade.model';
import { InputText } from 'primeng/inputtext';
import { Select } from "primeng/select";
import { WalletStoreService } from '../../services/etiquette-service/wallet-store.service';
import { EtiquetteStoreService } from '../../services/etiquette-service/etiquette-store.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'spike-trade-filters-form',
  providers: [],
  imports: [CommonModule, FormsModule, InputText, Select],
  templateUrl: './trade-filters-form.html',
})
export class TradeFiltersFormComponent extends AbstractComponent {
  public readonly walletStore = inject(WalletStoreService);
  public readonly etiquetteStore = inject(EtiquetteStoreService);

  filter = model.required<Trade>();

  wallets = this.walletStore.getList();
  etiquettes = this.etiquetteStore.getList();

  public tradeTypes = [
    { label: 'Entrata', value: 1 },
    { label: 'Uscita', value: 2 },
    { label: 'Giroconto', value: 3},
    { label: 'Investimenti', value: 4}
  ];

  public monthsList = [
    { label: 'Gennaio', value: 1 },
    { label: 'Febbraio', value: 2 },
    { label: 'Marzo', value: 3 },
    { label: 'Aprile', value: 4 },
    { label: 'Maggio', value: 5 },
    { label: 'Giugno', value: 6 },
    { label: 'Luglio', value: 7 },
    { label: 'Agosto', value: 8 },
    { label: 'Settembre', value: 9 },
    { label: 'Ottobre', value: 10 },
    { label: 'Novembre', value: 11 },
    { label: 'Dicembre', value: 12 }
  ];
  resetFilters() {
    this.filter.set({} as Trade);
    this.applyFilters();
  }

  applyFilters() {
    const currentFilters = this.filter();
    console.log('Filtri applicati:', currentFilters);
    // Qui chiami il tuo asyncApi.search(...) passando i filtri
  }

  onFieldChange(field: keyof Trade, value: any) {
    this.filter.update(prev => ({ ...prev, [field]: value }));
  }

}
